import PropTypes from 'prop-types';
import {
  ArrowTrendingUpIcon,
  ArrowUturnLeftIcon,
  BookOpenIcon,
  BuildingOffice2Icon,
  BuildingStorefrontIcon,
  CalendarDaysIcon,
  CalendarIcon,
  ChartBarIcon,
  ChatBubbleLeftRightIcon,
  CheckCircleIcon,
  ClockIcon,
  Cog6ToothIcon,
  CreditCardIcon,
  CubeIcon,
  EllipsisHorizontalCircleIcon,
  EyeIcon,
  FolderIcon,
  GiftIcon,
  GlobeAltIcon,
  MegaphoneIcon,
  PencilSquareIcon,
  PhoneIcon,
  PlusCircleIcon,
  PresentationChartLineIcon,
  QuestionMarkCircleIcon,
  ReceiptPercentIcon,
  ShoppingCartIcon,
  SignalIcon,
  Squares2X2Icon,
  TagIcon,
  TrophyIcon,
  UserGroupIcon,
  UserIcon,
  UsersIcon,
  WalletIcon,
} from '@heroicons/react/24/solid';

const ICON_MAP = {
  storeDashboard: BuildingStorefrontIcon,
  dashboard: Squares2X2Icon,
  salesDashboard: ArrowTrendingUpIcon,
  customers: UsersIcon,
  marketing: MegaphoneIcon,
  loyalty: GiftIcon,
  channels: SignalIcon,
  inventory: CubeIcon,
  annotate: PencilSquareIcon,
  reports: ChartBarIcon,
  orders: ShoppingCartIcon,
  returns: ArrowUturnLeftIcon,
  giftCards: WalletIcon,
  rewards: TrophyIcon,
  files: FolderIcon,
  invoices: ReceiptPercentIcon,
  people: UserIcon,
  stores: BuildingOffice2Icon,
  eventTypes: TagIcon,
  bookings: CalendarDaysIcon,
  availability: ClockIcon,
  calendar: CalendarIcon,
  website: GlobeAltIcon,
  calendarSettings: Cog6ToothIcon,
  doctors: UserGroupIcon,
  serviceAssistant: ChatBubbleLeftRightIcon,
  create: PlusCircleIcon,
  dataViz: PresentationChartLineIcon,
  review: EyeIcon,
  verify: CheckCircleIcon,
  billing: CreditCardIcon,
  apiDoc: BookOpenIcon,
  help: QuestionMarkCircleIcon,
  more: EllipsisHorizontalCircleIcon,
  settings: Cog6ToothIcon,
  voice: PhoneIcon,
};

const FALLBACK_ICON = Squares2X2Icon;

function NavigationIcon({
  iconKey,
  isActive = false,
  disabled = false,
  size = 20,
  className = '',
}) {
  const Icon = ICON_MAP[iconKey] || FALLBACK_ICON;

  const colorClass = disabled
    ? 'text-secondary-100'
    : isActive
      ? 'text-primary-900'
      : 'text-darkGrey-400 group-hover:text-primary-900';

  return (
    <Icon
      aria-hidden
      style={{ width: size, height: size }}
      className={`flex-shrink-0 transition-colors duration-200 ${colorClass} ${className}`}
    />
  );
}

NavigationIcon.propTypes = {
  iconKey: PropTypes.string,
  isActive: PropTypes.bool,
  disabled: PropTypes.bool,
  size: PropTypes.number,
  className: PropTypes.string,
};

export default NavigationIcon;
